import React, { Suspense, useState } from 'react';
import { Sidebar } from './shell/Sidebar';
import { TopBar } from './shell/TopBar';
import { PageSkeleton } from './Skeleton';
// Direct import, not the ./ui barrel: the barrel pulls every UI component into main.js.
import { ConfirmProvider } from './ui/ConfirmDialog';

// The app shell (ADR-49): full-width pages, a collapsible sidebar that stays
// in place while the page scrolls, and a top bar.
const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  return (
    <ConfirmProvider>
      <div className="flex min-h-screen bg-canvas text-body">
        <Sidebar mobileOpen={menuOpen} onMobileClose={() => setMenuOpen(false)} />
        <div className="flex min-w-0 flex-1 flex-col">
          <TopBar onOpenMenu={() => setMenuOpen(true)} />
          <main id="main" className="flex-1 px-4 py-6 sm:px-6 lg:px-8">
            {/* Pages are lazy-loaded (DATA-340): the shell stays put while a
                page's code downloads. */}
            <Suspense fallback={<PageSkeleton />}>{children}</Suspense>
          </main>
        </div>
      </div>
    </ConfirmProvider>
  );
};

export default Layout;
